import { getRecordingIdsString, getRecordingIdsStringByStorage } from 'Utils/itemUtils';
import { useStore } from 'Store';
import { getRecPlatformsFromUserData } from './Recordings';

export const useGetRealId = () => {
    const { userData } = useStore();

    return (recording) => {
        const recordingIds = recording.ids;
        const recordedOnBothPlatforms = Boolean(recordingIds.iptv && recordingIds.go);
        return recordedOnBothPlatforms
            ? getRecordingIdsStringByStorage(recordingIds, getRecPlatformsFromUserData(userData))
            : getRecordingIdsString(recordingIds);
    };
};
